// 휴대폰 형식변환
// 00000000000 to 000-0000-0000
module.exports = (serial) =>
{
  if(serial.length<10) return serial;
  return serial.substr(0, 3) + "-" + serial.substr(3, 4) + "-" + serial.substr(7, 4)
}